export const TRANSLATIONS_EN = {
 "header.home" : "Home" ,
 "header.admin" : "Admin" ,
 "header.analytic": "Analytics",
 "header.admin.users": "Users",
 "header.admin.addUser": "Add User",
 "header.admin.companies": "Companies",
 "header.admin.subsidiary": "Subsidiaries",
 "header.admin.partner": "Suppliers",
 "header.admin.dept": "Company Departments",
 "header.admin.loc": "Company Locations",
 "header.admin.prod": "Products",
 "header.admin.commodity": "Commodity",
 "header.admin.comprod": "Company Products",
 "header.admin.comsurv": "Company Survey",
 "header.admin.surveyprod": "Company Survey Products",
 "header.admin.partnerDelegate": "Supplier Delegate",
 "header.settings": "Settings",
 "header.settings.manageMFA": "Manage MFA",
 "header.settings.enableMFA": "Enable MFA",
 "header.settings.disableMFA": "Disable MFA",
 "header.login": "Login",
 "header.logoff": "Logoff",
 "header.hello": "Hello",
 "header.admin.DelegateLocation":"Supplier Delegate Location",
 "header.admin.DelegateProduct":"Supplier Delegate Product",
 "header.admin.partnerDelegateAppSurvey":"Supplier Delegate App Survey",
 "header.admin.delegate":"Supply Chain",
 "header.supply-chain":"Supply Chain Update",
 "header.admin.supply-chain.display":"Display Supply Chain",
 "header.admin.neverLoggedInUsers":"List Never Logged In Users",
 "header.admin.users.neverLoggedIn":"Users who have never logged in",
 "header.admin.supply-chain.edit":"Edit Supply Chain",
 
 "page.option.mycompany": "My Company",
 "footer.contactUs": "Contact Us",
 "footer.support": "Support",
 "footer.emailUs": "Email us at",
 "page.select": "Select a value",
 "page.createAccount": "Create Your Account",
 "page.name": "Name",
 "page.email": "Email",
 "page.password": "Password",
 "page.choosePassword": "Choose Password",
 "page.retypePassword": "Retype Password",
 "page.address1": "Address Line1",
 "page.address2": "Address Line2",
 "page.city": "City",
 "page.country": "Country",
 "page.state": "State",
 "page.zipCode": "Zip Code",
 "page.zipExt": "Zip Extn",
 "page.phone": "Phone",
 "page.timezone": "Timezone",
 "page.language": "Language",
 "page.role": "Role",
 "page.interests": "Interests",
 "page.appAccess": "App Access",
 "page.application": "Application",
 "page.subDate": "Subscription Date",
 "page.addRow": "Insert Row",
 "page.delRow": "Delete Row",
 "page.active": "Active",
 "page.active.not": "Not Active",
 "page.id": "Id",
 "page.status": "Status",
 "page.MFAStatus": "MFA Status",
 "page.action": "Action",
 "page.address": "Address",
 "page.company": "Company",
 "page.userType": "User Type",
 "page.subsidiary": "Subsidiary",
 "page.partner": "Partner",
 "page.buyer": "Buyer",
 "page.supplier": "Supplier",
 "page.parentcompany": "Parent Company",
 "page.uom": "Unit Of Measure",
 "page.latitude": "Latitude",
 "page.longitude": "Longitude",
 "page.contactName": "Contact Name",
 "page.contactEmail": "Contact Email",
 "page.companyURL": "Company Website",
 "page.english": "English",
 "page.spanish": "Spanish",
 "page.arabic": "Arabic",
 "page.turkish": "Turkish",
 "page.serb.cyrl": "Serbian (Cyrillic)",
 "page.serb.latn": "Serbian (Latin)",
 "page.french": "French",
 "page.signup": "Sign up",
 "page.search": "Search",
 "page.clear": "Clear",
 "page.loading": "Loading",
 "page.enabled": "Enabled",
 "page.disabled": "Disabled",
 "page.delete": "Delete",
 "page.undelete": "UnDelete",
 "page.edit": "Edit",
 "page.multi.comp": "Is Multi Company",
 "page.page": "Page",
 "page.goToPage": "Go to page",
 "page.openApp": "Open ",
 "page.of": "of",
 "page.submit": "Submit",
 "page.cancel": "Cancel",
 "page.upload": "Upload",
 "page.answer": "Answer",
 "page.note": "Note",
 "page.provisioning": "Provisioning",
 "page.generateRpt":"Search Survey",
 "page.add.note": "Add Note",
 "page.add.response": "Add Response",
 "page.login": "Login",
 "page.questionnaire": "Questionnaire",
 "page.location":"Location",
 "page.product":"Product",
 "page.eval":"Evaluation",
 "page.eval.level":"Evaluation Levels",
 "page.high":"High",
 "page.medium":"Medium",
 "page.low":"Low",
 "page.ready":"Ready",
 "page.inspect":"Inspect",
 "page.pause":"Pause",
 "page.incomplete":"Incomplete",
 "page.green":"Green",
 "page.yellow":"Yellow",
 "page.orange":"Orange",
 "page.chartType":"Chart Type",
 "page.locationcompany": "Company",
 "page.login.forgotPassword":"Forgot Password",
 "page.login.needHelp":"Need Help?",
 "page.login.changePassword":"Change Password",
 "page.login.verifyUser":"Verify User",
 "page.login.sendCode":"Send New Verification Code",
 "page.qrcodeScan": "Scan the QR Code display below using any Authenticator App like Google Authenticator, Microsoft Authenticator etc",
 "page.inputToken": "Please input the token from the authenticator",
 "page.showDetails": "Show Details",
 "page.changePasswd.goBackTo":"Go back to",
 "page.changePasswd.oldPassword":"Old Password",
 "page.changePasswd.newPassword":"New Password",
 "page.forgotPasswd.toResetPassword":"To reset the password",
 "page.forgotPasswd.step1":"1. Request for a verification code which will be sent to your email id.",
 "page.forgotPasswd.step2":"2. Input the verification code received along with the new password in the fields below and submit the request.",
 "page.forgotPasswd.step1.1":"Step 1. Provide the registered email id to generate a verification code.",
 "page.forgotPasswd.step1.2":"Please check your email for the verification code after you submit the request.",
 "page.forgotPasswd.step2.1":"Step 2. Input the emailed verification code and new password in the fields below and submit the request.",
 "page.forgotPasswd.verificationCode":"Verification Code",
 "page.verification.verifyAccount":"Verify your Account",
 "page.verification.checkEmail":"Please check your registered email for the verification code.",
 "page.resendCode.resend":"Resend Verification Code",
 "page.manageMFA.token":"Token is required.",
 "page.MFAModel.header":"Provide Multi-factor authentication token from Authenticator App",
 "page.MFAModel.token":"Token",
 "page.MFAModel.reset":"Reset Multi-factor Auth",
 "page.editUser":"Edit User",
 "page.close":"Close",
 "page.pending":"Pending",
 "page.completed":"Completed",
 "page.update":"Update",
 "page.company.type":"Company Type",
 "page.company.name":"Company Name",
 "page.company.group":"Company Group",
 "page.entity":"Entity",
 "page.subsidiary.add": "Add Subsidiary",
 "page.partner.add": "Add Buyer Access",
 "page.partner.edit": "Edit Buyer Access",
 "page.buyer.add": "Add Buyer",
 "page.supplier.add": "Add Supplier",
 "page.company.add": "Add Company",
 "page.company.edit": "Edit Company",
 "page.user.type": "User Type",
 "page.startDate": "Start Date",
 "page.endDate": "End Date",
 "page.firstName": "First Name",
 "page.lastName": "Last Name",
 "page.dept":"Department",
 "page.dept.name":"Department Name",
 "page.dept.type":"Department Type",
 "page.dept.add": "Add Department",
 "page.dept.edit":"Edit Department",
 "page.description": "Description",
 "page.loc":"Location",
 "page.loc.name":"Location Name",
 "page.loc.add": "Add Location",
 "page.loc.edit":"Edit Location",
 "page.process":"Process",
 "page.productGrp":"Product Group",
 "page.commoName": "Commodity Name",
 "page.prodName": "Product Name",
 "page.prodNum": "SKU",
 "page.analytics": "Analytics",
 "page.prod": "Product",
 "page.commodity": "Commodity",
 "page.lotcode": "Lot Code",
 "page.finishedLotCode": "Finished Product Lot",
 "page.appAccess": "App Access",
 "page.appSurvey": "App Survey",
 "page.app.name": "App Name",
 "page.survey.name": "Survey Name",
 "page.survey.review": "Review Required",
 "page.survey.share": "Share Manually",
 "page.survey.addown": "Added By this Company",
 "page.survey.addbuyer": "Added By Buyer",
 "page.read": "Can Read",
 "page.read.own": "Only Read Buyer Survey",
 "page.read.medhigh": "Can Only Read High Scores",
 "page.write": "Can Write",
 "page.review": "Can Review",
 "page.read.sup": "Read Supplier Survey",
 "page.write.sup": "Write Supplier Survey",
 "page.review.sup": "Review Supplier Survey",
 "page.corr.sup": "Corrective Action Supplier Survey",
 "page.write.buy": "Write Buyer Survey",
 "page.review.buy": "Review Buyer Survey",
 "page.write.own": "Write Own Survey",
 "page.review.own": "Review Own Survey",
 "page.read.own": "Read Own Survey",
 "page.loc.buyer":"Buyer Location",
 "page.canTakeCorrectiveAction": "Access Corrective Action",
 "page.priority.buyer.score":"Priority to Buyer Score",
 
 "page.oper.type":"Operation Type",
 "page.oper.area":"Operation Area",
 "page.oper.area.1":"Type",
 "page.oper.name":"Operation",
 "page.confirmationMessage": "Are you sure?",
 "page.details":"Details",
 "page.option": "Option",
 "page.subOption": "Sub Option",
 "page.search.plc": "Search...",
 "page.harvest.lotscore": "Harvest Lot Score",
 "page.finish.lotscore": "Finished Lot Score",
 "page.harvest.bol.abrv":"BOL",
 "page.harvest.bol.assess":"BOL Assessment",
 "page.harvest.bol":"Bill Of Lading",
 "page.po.numscore": "PO# Score",
 "page.survey.alert": "Survey Alert",
 "page.weekly": "Weekly Alert",
 "page.monthly": "Monthly Alert",
 "page.yearly": "Yearly Alert",
 "page.dow": "Day Of Week",
 "page.anyday": "Any Day",
 "page.mon": "Monday",
 "page.tue": "Tuesday",
 "page.wed": "Wednesday",
 "page.thu": "Thursday",
 "page.fri": "Friday",
 "page.sat": "Saturday",
 "page.sun": "Sunday",
 "page.alert.notcomplete": "Not Completed Alert",
 "page.alert.complete": "Completed Alert",
 "page.alert.highscore": "High Score Alert",
 "page.analytics.name": "Analytics Name",
 "page.analytics.info": "Please select an analytics type from the top menu.",
 "page.farm.product" : "Farm Product Score",
 "page.productionDate": "Production Date",
 "page.harvestDate": "Harvest Date",
 "page.repackDate": "Blend/Repack Date",
 "page.score": "Score",
 "page.tracepo":"PO # / Traceability #",
 "page.shipdate":"Shipping Date",
 "page.ship.assess":"Shipping Assessment",
 "page.prod.trend": "SKU Production Trend Analysis",
 "page.prod.raw": "Raw Product",
 "page.prod.finish": "Finished Product",
 "page.companyNumber": "Company Number",
 "page.suplrNumber": "Supplier Number",
 "page.survey.canadd": "Buyer Add Survey",
 "page.broker.share": "Share Buyer's Survey",
 "page.provisioned.attribute": "Provisioned Attribute",
 "page.provisioned.value": "Value",
 "page.change.analytics": "Change Analytics",
 "page.multi.product": "Multiple Product",
 "page.HepA.vaccination": "Hepatatis-A Vaccination",
 "page.water.source": "Water Source",
 "page.unknown": "Unknown",
 "page.water.equip.clean": "Equipment Cleaning Water Source",
 "page.water.fruit.clean": "Fruit Wash Water",
 "page.worker.regional.location": "Worker Nationality/Regional Locaiton",
 "page.housing.density": "Housing Density",
 "page.human.biosolid.use": "Human Biosolid use on farm",
 "page.waste.treatment": "Waste Treatment",
 "page.water.potable": "Is water potable",
 "page.HepA.vaccination.rate": "Hepatatis-A Vaccination Rate",
 "page.freq": "Frequency",
 "page.deviceAccess": "Device Access",
 "page.yes": "Yes",
 "page.no": "No",
 "page.secondarySupplierName": "Secondary Supplier Name",
 "page.farm.annual.assessments":"Farm Annual Assessments",
 "page.facility.annual.assessments":"Facility Annual Assessments",
 "page.finished.product.assessments":"Finished Product Assessments",
 "page.shipment.assessments":"Shipment Assessments",
 "page.facilities":"Facilities",
 "page.facility":"Facility",
 "page.prod.assess":"Production Assessments",
 "page.inc.assess":"Incoming Product Assessments",
 "page.corr.action":"Corrective Actions",
 "page.grower":"Growers",
 "page.harvest.assess":"Harvest Assessments",
 "page.level":"Level",
 "page.parentSupplierName":"Parent Supplier",
 "page.next":"Next",
 "page.back":"Back",
 "page.delete.details":"Delete Details",
 "page.setDates":"Set Dates",
 "page.supplier.dates":"Supplier Dates",
 "page.dates.access":"Access Dates",
 "page.supplyChain": "Supply Chain",
 "page.take.corr.action": "Take Corrective Actions",
 "page.completed.corr.action": "Completed Corrective Actions",
   
 "error.MFATokenError": "Multi-factor Authentication token provided is not valid.",
 "error.MFAAuthFailed": "Multi-factor Authentication failed ",
 "error.MFAStateError": "There was error in changing the MFA state.",
 "error.error": "Error : ",
 "error.system.fetch": "Application error occurred, data was not retrieved",
 "error.system.update": "Application error occurred, data was not updated",
 "error.userAuthFailed":"User Authentication Failed.",
 "error.userReqd":"User id is required",
 "error.emailReqd":"Email is required",
 "error.passwdReqd":"Password is required",
 "error.changePasswordFailed":"Password change failed. Please try again later",
 "error.invalidEmail":"Please provide a valid email id",
 "error.oldPasswdReqd":"Old Password is required",
 "error.weakPassword":"Please choose a strong password with minimum 8 characters, a number and a special character",
 "error.sendCodeError":"Sending verification code for resetting the password failed. Please try again later",
 "error.codeReqd":"Verification Code is required.",
 "error.verificationFailed":"Verification failed. Please try again later",
 "error.resendVerificationFailed":"Resend verification code failed. Please try again later",
 "error.MFASetupFailed":"The Multi Factor Authentication cannot be currently setup",
 "error.tokenVerifyFailed":"Token verification failed. Please try again later",
 "error.MFAStateChangeFailed":"There was error in changing the MFA state.",
 "error.unhandledException":"Unhandled action type",
 "error.userListNotRetrieved":"User list could not be retrieved",
 "error.userDeleteFailed":"User delete failed",
 "error.getInterestFailed":"Interests list could not be retrieved",
 "error.getRoleFailed":"Roles list could not be retrieved",
 "error.getAppNamesFailed":"Application name list could not be retrieved",
 "error.getTimezoneFailed":"Timezone list could not be retrieved",
 "error.getStateFailed":"State list could not be retrieved",
 "error.getCountryFailed":"Country list could not be retrieved",
 "error.getUOMFailed":"Unit Of Measure list could not be retrieved",
 "error.getUserSubTypeFailed":"User Sub Type list could not be retrieved",
 "error.getDeptTypeFailed":"Department Type list could not be retrieved",
 "error.getProcessNamesFailed":"Process name list could not be retrieved",
 "error.getProdGrpFailed":"Product Group list could not be retrieved",
 "error.getProdFailed":"Product list could not be retrieved",
 "error.userNameReqd":"Username is required",
 "error.firstNameReqd":"First name is required",
 "error.lastNameReqd":"Last name is required",
 "error.userTypeReqd":"User type is required",
 "error.stateReqd":"State is required",
 "error.countryReqd":"Country is required",
 "error.interestReqd":"Interest is required",
 "error.userEditFailed":"Customer information could not be updated",
 "error.addUserFailed":"New Customer was not added",
 "error.verifyEmail":"User needs to verify the email address using the verification code emailed",
 "error.retypePasswdReqd":"Retype Password is required",
 "error.passwdMatchFailed":"Passwords do not match",
 "error.companyListNotRetrieved":"Company list could not be retrieved",
 "error.companyDeleteFailed":"Deletion of Company failed",
 "error.getCompanyTypeFailed":"Company Type list could not be retrieved",
 "error.getCompanyGroupFailed":"Company Group list could not be retrieved",
 "error.getEntityFailed":"Entity list could not be retrieved",
 "error.companyNameReqd":"Company Name is required",
 "error.companyTypeReqd":"Company Type is required",
 "error.companyEditFailed":"Company information was not updated",
 "error.companyReqd":"Company is required",
 "error.appName.Reqd":"App Name is required",
 "error.appName.appRole.Reqd":"App Name and App Role is required",
 "error.only1RowAllowed":"You can add only 1 row at a time",
 "error.appAccessDup":"Access for Application is already present",
 "error.appAccessEditFailed":"Application Access change failed",
 "error.newRowAdded":"New row is already added",
 "error.subsidiaryNotRetrieved":"Subsidiary list could not be retrieved",
 "error.subsidiaryReqd":"Subsidiary should be selected else cancel the request by clicking close",
 "error.subsidiaryDeleteFailed":"Deletion of Subsidiary failed",
 "error.partnerNotRetrieved":"Supplier list could not be retrieved",
 "error.partnerReqd":"Client company should be selected else cancel the request by clicking close",
 "error.startdateReqd":"Start date is mandatory",
 "error.partnerDeleteFailed":"Deletion of Supplier failed",
 "error.deptTypeReqd":"Department Type is required",
 "error.deptNameReqd":"Department Name is required",
 "error.deptNotRetrieved":"Department list could not be retrieved",
 "error.deptReqd":"Department should be selected else cancel the request by clicking close",
 "error.deptDeleteFailed":"Department could not be deleted",
 "error.deptEditFailed":"Department information could not be updated",
 "error.userDeptEditFailed":"Department change failed",
 "error.userDeptDup":"Department is already present",
 "error.locNameReqd":"Location Name is required",
 "error.locNotRetrieved":"Location list could not be retrieved",
 "error.locReqd":"Location should be selected else cancel the request by clicking close",
 "error.locDeleteFailed":"Location could not be deleted",
 "error.locEditFailed":"Location information could not be updated",
 "error.deptProcDup":"Process is already present",
 "error.deptProcDeleteFailed":"Process could not be deleted",
 "error.deptProcEditFailed":"Modifying the Department Process failed",
 "error.deptProc.Reqd":"Process is required",
 "error.searchProdInvalid":"Either select the Product Group or provide minimum 3 letters of product name to search",
 "error.prodEditFailed":"Modifying the Product failed",
 "error.commoEditFailed":"Modifying the Commodity Information failed",
 "error.prodGrp.Reqd":"Product Group is required",
 "error.prodDup":"Product is already present",
 "error.prodName.Reqd":"Product Name is required",
 "error.commoName.Reqd":"Commodity Name is required",
 "error.commodityKey.Reqd":"Commodity is required",
 "error.userGetProdFailed":"Product list for user could not be retrieved",
 "error.userProdEditFailed":"Modifying the Product failed",
 "error.locDup":"Location is already present",
 "error.userGetLocFailed":"Location list for user could not be retrieved",
 "error.userLocEditFailed":"Modifying the Location failed",
 "error.sessionTimeout":"Session has timed out. Please login again.",
 "error.logoutFailed":"Logout Failed.",
 "error.appSurveyNameReqd":"App and Survey is required",
 "error.getAppSurveyFailed":"The list of survey names could not be retrieved",
 "error.userGetAppSurveyFailed":"The list of surveys for the user could not be retrieved",
 "error.compGetAppSurveyFailed":"The list of surveys for the company could not be retrieved",
 "error.userAppSurveyEditFailed":"Modifying the App/Survey access failed",
 "error.userAppSurveyDup":"App/Survey is already present, please update existing entry",
 "error.partnerGetAppSurveyFailed":"The list of surveys for the partner companies could not be retrieved",
 "error.partnerAppSurveyEditFailed":"Modifying the App/Survey access failed",
 "error.partnerAppSurveyDup":"App/Survey is already present, please update existing entry",
 "error.operTypeReqd":"Operation Type is required",
 "error.operAreaReqd":"Operation Area is required",
 "error.userGetPartnerFailed":"The list of Suppliers for the user could not be retrieved",
 "error.userPartnerEditFailed":"Modifying the Supplier access failed",
 "error.userPartnerDup":"Supplier is already present, please update existing entry",
 "error.endDateBeforeStartDate":"End Date is before Start Date",
 "error.userGetSubsidiaryFailed":"The list of subsidiaries for the user could not be retrieved",
 "error.userSubsidiaryEditFailed":"Modifying the Subsidiary access failed",
 "error.userSubsidiaryDup":"Subsidiary is already present, please update existing entry",
 "error.suplrReqd":"Supplier is required",
 "error.partnerGetAppSurveyFailed":"The list of App Surveys for user and supplier could not be retrieved",
 "error.partnerGetDepartmentFailed":"The list of departments for user and supplier could not be retrieved",
 "error.partnerGetLocFailed":"Location list for supplier could not be retrieved",
 "error.partnerGetProdFailed":"Product list for supplier could not be retrieved",
 "error.partnerGetSurveyAlertFailed":"The list of alerts for the supplier could not be retrieved",
 "error.subsidiaryGetAppSurveyFailed":"The list of App Surveys for user and subsidiary could not be retrieved",
 "error.subsidiaryGetDepartmentFailed":"The list of Departments for user and subsidiary could not be retrieved",
 "error.subsidiaryGetLocFailed":"The list of Locations for user and subsidiary could not be retrieved",
 "error.subsidiaryGetProdFailed":"Product list for subsidiary could not be retrieved",
 "error.userGetSurveyAlertFailed":"The list of alerts for the user could not be retrieved",
 "error.userSurveyAlertEditFailed":"Modifying the Survey alert failed",
 "error.userSurveyAlertDup":"Survey Alert is already present, please update existing entry",
 "error.getAnalyticsFailed":"Analytics list could not be retrieved",
 "error.userGetAnalyticsFailed":"The list of analytics for the user could not be retrieved",
 "error.Analytics.NoSurvey":"Surveys not found for the Supplier",
 "error.userAnalyticsEditFailed":"Modifying the analytics access failed",
 "error.userAnalyticsDup":"Analytics is already present, please update existing entry",
 "error.analyticsNameReqd":"Analytics is required",
 "error.analytics.nodata": "Data not found for the search criteria",
 "error.provNotRetrieved": "User Provisioning could not be retrieved",
 "error.userProvEditFailed": "Modifying the User Provisioning failed",
 "error.attributeReqd": "Attribute is required",
 "error.duplicate.attribute": "Attribute already provisioned",
 "error.getLocationProvisionFailed":"Company-Location Provision List could not be retrieved",
 "error.hepA.float":"Hepatatis-A vaccination percentage should be a decimal number",
 "error.phoneReqd": "Phone number is required for device access",
 "error.getSurveyListFailed":"Survey list could not be retrieved",
 "error.survey.Reqd":"Survey is required",
 "error.prod.Reqd":"Product is required",
 "error.supplierListNotRetrieved":"Supplier list could not be retrieved",
 "error.supplier.Reqd":"Supplier is required",
 "error.buyer.Reqd":"Buyer is required",
 "error.partnerDelegateNotRetrieved":"Supplier Delegate could not be retrieved",
 "error.partnerDelegateDeleteFailed":"Deletion of Supplier Delegate failed",
 "error.partnerDelegateDup":"Supplier Delegate is already present",
 "error.partnerDelegateSaveFailed":"Supplier Delegate could not be saved",
 "error.invalid.delegate.relation":"Buyer and Delegate cannot be same",
 "error.indirectBuyer.Reqd":"Indirect Buyer required",
 "error.delegateLocationNotRetrieved":"Delegate Location could not be retrieved",
 "error.delegateLocationDeleteFailed":"Deletion of Delegate Location failed",
 "error.delegateLocationDup":"Delegate Location already provisioned",
 "error.delegateLocKey.Reqd":"Delegate Location not found for updation",
 "error.delegateLocationSaveFailed":"Failed to save Delegate Location",
 "error.delegateProductNotRetrieved":"Delegate Product could not be retrieved",
 "error.delegateProductDeleteFailed":"Deletion of Delegate Product failed",
 "error.delegateProductDup":"Delegate Product already provisioned",
 "error.delegateProdKey.Reqd":"Delegate Product not found for updation",
 "error.delegateProductSaveFailed":"Failed to save Delegate Product",
 "error.onlyEditAllowed":"Save/Cancel the edit operation",
 "error.location.Reqd":"Location is required",
 "error.partnerNumber.invalid":"Invalid Partner Number. Only Alphanumeric and _, - characters allowed",
 "error.delegateAppSurveyNotRetrieved":"Delegate App Survey could not be retrieved",
 "error.delegateAppSurveyDeleteFailed":"Deletion of Delegate App Survey failed",
 "error.delegateAppSurveyDup":"Delegate App Survey already provisioned",
 "error.surveyDelegateKey.Reqd":"Delegate App Survey not found for updation",
 "error.delegateAppSurveySaveFailed":"Failed to save Delegate App Survey",
 "error.parentSupplierNotRetrieved":"Parent Supplier could not be retrieved",
 "error.invalid.parent.child.relation":"Secondary Supplier cannot be same as Parent Supplier",
 "error.parentSupplier.Reqd":"Parent Supplier is required",
 "error.delegateKeyReqd":"Delegate is required",
 "error.userDelegateNotRetrieved":"User Delegate could not be retrieved",
 "error.userDelegateDeleteFailed":"Deletion of User Delegate failed",
 "error.userDelegateDup":"User Delegate is already present",
 "error.userDelegateSaveFailed":"User Delegate could not be saved",
 "error.userDelegateEditFailed":"Modifying the User Delegate failed",
 "error.delegateNotRetrieved":"Delegate could not be retrieved",
 "error.delegateGetAppSurveyFailed":"The list of App Surveys for user and delegate could not be retrieved",
 "error.userDelegateKeyReqd":"User Delegate is required",
 "error.delegateGetLocationFailed":"The list of Locations for user and delegate could not be retrieved",
 "error.delegateGetProductFailed":"The list of Products for user and delegate could not be retrieved",
 "error.onlyOneOpAllowed":"Only one operation is allowed",
 "error.userDetailsDeleteFailed":"User details delete failed",
 "error.partnerGetDateFailed":"The list of dates for the supplier could not be retrieved",
 "error.partnerDateEditFailed":"Modifying the Supplier Date failed",
 "error.datesOverlap":"Overlapping dates",
 "error.buyerListNotRetrieved":"Buyer list could not be retrieved",
 "error.neverLoggedInUsersNotRetrieved":"List of users who have never logged in could not be retrieved",
 "error.rowNotSelected":"Select the checkbox across the row for which data needs to be added",
 "error.buyerNotSelected":"Buyers not selected",
 "error.supplyChainEditFailed":"Adding buyers to the Supply Chain failed",
 
 "confirm.delete.details":"Are you sure you want to delete the user provisions?",
 "confirm.change.user.company":"User company can only be changed after deleting the user provisions. Are you sure you want to delete the user provisions?",
 
 "info.success.stored": "Successfully stored the information",
};